import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ControlNumberInput } from '../../../common/ControlNumberInput';

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

export const ShadowOpacityControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    const handleChange = (value: number) => {
        const shadowOpacity = parseFloat((value / 100).toFixed(2));

        avatarElement.set({ shadowOpacity });
    };

    const shadowOpacity = Math.round(avatarElement.shadowOpacity * 100);

    return (
        <Container>
            <StyledSlider value={shadowOpacity} onChange={(_e, value) => handleChange(value as number)} step={1} min={0} max={100} />
            <ControlNumberInput value={shadowOpacity} onChange={handleChange} min={0} max={100} suffix="%" />
        </Container>
    );
});
